// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__1TK1I","small":"Icon_small__3QB-Q","medium":"Icon_medium__3JzV5","large":"Icon_large__tuPqW"};